<template>
  <div id="box">
    <div :class="navBarFixed == true ? 'navBarWrap' :''">
      <div class="header">
      <div class="logo_img" @click="logoClick">
        <div style="display:flex; align-items: center; float:left; height: 60px;">
          <div class="header-logo">
            <img v-if="!navBarFixed" id="header-img" src="../../static/common/logo.png">
            <img v-if="navBarFixed" id="header-img" src="../../static/common/logowhite.png" alt="">
          </div>
        </div>
      </div>
      <div id="menu_index">
        <!-- wap端菜单按钮 -->
        <div v-if="isWap" class="wapMenuBtn" :class="wapMenuShow ? 'wapMenuBtnOpen' : ''" @click="toggleWapMenu">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <!-- web端菜单导航 -->
        <el-menu
          v-if="!isWap"
          :default-active="activeIndex" 
          class="el-menu-demo" 
          menu-trigger="click" 
          text-color="#fafafa"
          style="height: 60px; border:0;" 
          mode="horizontal" 
          @select="handleSelect">
          <el-menu-item index="1" class="header-title">
            <span>首页</span>
            <img v-if="activeIndex == 1" src="../../static/index/selectRed.png" alt="">
          </el-menu-item>
          <el-menu-item index="2" class="header-title">
            <span>关于我们</span>
            <img v-if="activeIndex == 2" src="../../static/index/selectRed.png" alt="">
          </el-menu-item>
          <el-menu-item index="3" class="header-title">
            <span>产品介绍</span>
            <img v-if="activeIndex == 3" src="../../static/index/selectRed.png" alt="">
          </el-menu-item>
          <el-menu-item index="4" class="header-title">
            <span>交易细则</span>
            <img v-if="activeIndex == 4" src="../../static/index/selectRed.png" alt="">
          </el-menu-item>
          <el-menu-item index="5" class="header-title">
            <span>平台公告</span>
            <img v-if="activeIndex == 5" src="../../static/index/selectRed.png" alt="">
          </el-menu-item>
          <!-- <el-menu-item index="5" class="header-title">
            <span>联系客服</span>
            <img v-if="activeIndex == 5" src="../../static/index/selectRed.png" alt="">
          </el-menu-item> -->
        </el-menu>
      </div>
      <div class="login">
        <span @click="goLogin">登录</span>
        <label for="">|</label>
        <span @click="goRegister">注册</span>
      </div>
      <!-- <div v-if="seen" style="float: right; display: flex;align-items: center; height: 100%;">
        <el-button type="text" style="margin-right: 20px;" class="header-title" @click="login">登录</el-button>
        <el-button type="primary" class="header-title" @click="register" round>注册</el-button>
      </div> -->
    </div>
    <!-- wap端下拉菜单 -->
    <div v-if="isWap" class="wapMenuMask" :class="wapMenuShow ? 'wapMenuMaskShow' : ''" @click="closeWapMenu"></div>
    <div v-if="isWap" class="wapMenu" :class="wapMenuShow ? 'wapMenuOpen' : ''">
      <ul>
        <li v-for="item in wapMenuList"
            :key="item.key"
            :class="activeIndex == item.key ? 'wapMenuActive' : ''"
            @click="wapSelect(item.key)">
          <span>{{item.name}}</span>
        </li>
      </ul>
    </div>
    <div id="back_to_top" ref="btn" @click="backTop" style="display: none;">
      <p style="font-size: 0.625em; font-weight: bold">TOP</p>
      <img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
    </div>
    </div>
  </div>
</template>

<script>
  import { wapMixin } from '../../utils/device';
  export default {
    name: "Layout",
    // props:['getSessinKey'],
    mixins: [wapMixin],
    data() {
      return {
        activeIndex: '1',
        // wap端菜单
        wapMenuShow: false,
        wapMenuList: [
          { key: '1', name: '首页' },
          { key: '2', name: '关于我们' },
          { key: '3', name: '产品介绍' },
          { key: '4', name: '交易细则' },
          { key: '5', name: '平台公告' },
        ],
        company: {
          qrcode: require("../../static/other/公众号二维码.jpg"),
        },
        scroll: '',
        timer: '',
        seen: true,
        currentMenu: '首页',
        navBarFixed: false,
        windowWidth: document.documentElement.clientWidth,  //实时屏幕宽度
      };
    },
    created(){
      this.activeIndex = sessionStorage.getItem('key') || '1';
      // 传递key值给父组件App.vue
      this.$emit('getKey', this.activeIndex);
    },
    mounted() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullWidth = document.documentElement.clientWidth;
          that.windowWidth = window.fullWidth; // 宽
        })()
      };
    },
    watch: {
      windowWidth (val) {
        let that = this;
        console.log("实时屏幕宽度：",val, that.windowWidth );
      },
      // 由wap切换到PC时收起wap菜单
      isWap (val) {
        if(!val){
          this.closeWapMenu();
        }
      },
      // 路由变化收起wap菜单
      $route(){
        this.closeWapMenu();
      }
    },
    methods: {
      // wap菜单展开/收起
      toggleWapMenu(){
        this.wapMenuShow = !this.wapMenuShow;
      },
      closeWapMenu(){
        this.wapMenuShow = false;
      },
      // wap菜单选择，复用PC端跳转逻辑
      wapSelect(key){
        this.closeWapMenu();
        if(this.activeIndex == key) return;
        this.handleSelect(key);
      },
      handleSelect(key) {
        this.$emit('getKey', key);
        sessionStorage.setItem('key',key);
        // this.getSessinKey(key);
        switch (key) {
          case '1':
            this.activeIndex = key;
            this.$router.push({
              name: "Index"
            });
            break;
          case '2':
            this.activeIndex = key;
            this.$router.push({
              name:'Aboutus'
            })
            break;
          case '3':
            this.activeIndex = key;
            this.$router.push({
              name: "introduce"
            });
            break;
          case '4':
            this.activeIndex = key;
            this.$router.push({
              name: "Details"
            });
            break;
          case '5':
            this.activeIndex = key;
            this.$router.push({
              name: "Notice"
            });
            break;
        }
      },
      handleScroll() {
        this.scroll = document.documentElement.scrollTop + document.body.scrollTop; //获取滚动后的高度
        if(this.scroll > 600) { //判断滚动后高度超过400px,就显示
          // this.$refs.btn.style.display = 'block';
        } else {
          // this.$refs.btn.style.display = 'none'
        }
        if(this.scroll > 90 ){
          this.navBarFixed = true;
        }else{
          this.navBarFixed = false;
        }
      },
      backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
        this.timer = setInterval(() => {
          let osTop = document.documentElement.scrollTop || document.body.scrollTop;
          let ispeed = Math.floor(-osTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
          if (osTop === 0) {
            clearInterval(this.timer)
          }
        }, 10)
      },
      login() {
        window.open('https://admin.fastice-tech.com/login')
      },
      register() {
        window.open('https://admin.fastice-tech.com/registe')
      },
      logoClick() {
        this.$router.push({
          name: "Index"
        });
        this.currentMenu = '首页';
      },
      goLogin(){
        window.open('https://www.rlc9000.com/uc/login')
      },
      goRegister(){
        window.open('https://www.rlc9000.com/uc/signUp/real')
      }
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll)
    },
  }
</script>

<style lang="less" scoped>
  #box{
    width: 100%;
    margin: 0 auto;
    background-color: #121212;
  }
  .logo_img {
    float: left;
    cursor: pointer;
  }

  #back_to_top {
    position: fixed;
    bottom: 50px;
    right: 30px;
    cursor: pointer
  }

  .header-title {
    font-size: 1em;
  }

  .company_name {
    font-weight: normal;
    font-size: 1em;
  }

  .footer_font {
    font-size: 1em;
  }

  #menu_index {
    height: 100%;
  }
  .login{
    color: #fff;
    cursor: pointer;
    label{
      margin: 0 15px;
      color: #bebdbd;
    }
  }
  /deep/ .el-menu--horizontal{
    background-color: #121212;
  }
  /deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus, .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover, .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
    background-color: #121212;
  }

  .header {
    margin: auto;
    width: 1135px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  #header-img {
    width: 115px;
    height: 31px;
    float: left;
    margin: 0 auto;
  }

  .header-logo {
    width: 115px;
    height: 27px;
  }

  .header-important {
    float: left;
    margin-left: 6px;
    align-self: center;
  }

  .footer {
    display: flex;
    align-items: center;
    margin: 10px auto;
    width: 90%;
  }
  /deep/ .el-menu--horizontal>.el-menu-item.is-active{
    color: #fafafa;
    border-bottom:0px solid #121212;
  }
  /deep/ .el-menu-item{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
  }
  .el-menu-item img{
    position: absolute;
    bottom:0px;
  }
  /deep/ .el-menu.el-menu--horizontal { // 去掉element-ui导航栏底部边框线
     border-bottom: none;
  }
  .header-title:focus {
    outline: none;
  }
  .navBarWrap {
    width: 100%;
    position:fixed;
    top:0;
    left: 50%;
    transform: translate(-50%,0);
    z-index:999;
    background-color: #121212;
    // transition: all .5s;
  }

  /* ---------------- wap端(≤768px) ---------------- */
  @media screen and (max-width: 768px) {
    #box{
      position: relative;
    }
    .header{
      width: 100%;
      height: 50px;
      box-sizing: border-box;
      padding: 0 12px;
      // 保证头部始终盖在下拉菜单遮罩之上
      position: relative;
      z-index: 1001;
    }
    // logo：去掉PC端的float，改用flex居中，保证与右侧登录/菜单按钮在同一水平线上
    .logo_img{
      order: 1;
      display: flex;
      align-items: center;
      height: 50px;
      float: none;
      div{
        height: 50px !important;
        float: none !important;
      }
    }
    .header-logo{
      width: 92px;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    #header-img{
      width: 92px;
      height: 25px;
      display: block;
      float: none;
      margin: 0;
    }
    .login{
      order: 2;
      margin-left: auto;
      margin-right: 15px;
      font-size: 14px;
      label{
        margin: 0 8px;
      }
    }
    #menu_index{
      order: 3;
      display: flex;
      align-items: center;
    }
    // 汉堡按钮
    .wapMenuBtn{
      width: 24px;
      height: 18px;
      position: relative;
      cursor: pointer;
      span{
        display: block;
        width: 100%;
        height: 2px;
        border-radius: 2px;
        background-color: #fafafa;
        position: absolute;
        left: 0;
        transition: all 0.3s;
      }
      span:nth-child(1){ top: 0; }
      span:nth-child(2){ top: 8px; }
      span:nth-child(3){ top: 16px; }
    }
    .wapMenuBtnOpen{
      span:nth-child(1){
        top: 8px;
        transform: rotate(45deg);
      }
      span:nth-child(2){
        opacity: 0;
      }
      span:nth-child(3){
        top: 8px;
        transform: rotate(-45deg);
      }
    }
    // 下拉菜单遮罩
    .wapMenuMask{
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.3s;
      z-index: 900;
    }
    .wapMenuMaskShow{
      opacity: 1;
      visibility: visible;
    }
    // 下拉菜单
    .wapMenu{
      width: 100%;
      position: absolute;
      top: 50px;
      left: 0;
      background-color: #1c1c1c;
      overflow: hidden;
      max-height: 0;
      transition: max-height 0.3s ease;
      z-index: 999;
      ul{
        width: 100%;
        li{
          width: 100%;
          height: 48px;
          box-sizing: border-box;
          padding: 0 20px;
          display: flex;
          align-items: center;
          color: #fafafa;
          font-size: 15px;
          border-bottom: 1px solid #2c2c2c;
          border-left: 3px solid transparent;
        }
        .wapMenuActive{
          color: #e1352a;
          border-left: 3px solid #e1352a;
        }
      }
    }
    .wapMenuOpen{
      max-height: 300px;
    }
  }
</style>